import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: '01',
  title: 'Kit de Emergencia para la Primera Toma',
  desc: 'Protocolo SOS de 5 min + secuencia del agarre + test de 30 seg',
  value: '$15.000'
}, {
  num: '02',
  title: 'Checklist de Agarre Perfecto en 60 Segundos',
  desc: '7 señales verdes + 7 alertas + método Mirá-Sentí-Escuchá',
  value: '$12.000'
}, {
  num: '03',
  title: 'Menú Express para Mamás Sin Tiempo',
  desc: 'Desayunos de 5 min + menú semanal + lista de compras + printable heladera',
  value: '$10.000'
}, {
  num: '04',
  title: 'Guía de Mitos de Lactancia',
  desc: '35 mitos desmontados + filtro mental + scripts para el entorno',
  value: '$12.000'
}, {
  num: '05',
  title: 'Planilla de Tomas, Pañales y Progreso',
  desc: 'Tracker 7 días + semáforo de indicadores + hoja para el pediatra',
  value: '$10.000'
}, {
  num: '06',
  title: 'Mini Guía de Calma para Mamás por Colapsar',
  desc: 'Protocolo 3 min + frases reales + rutina anti-colapso 3 AM',
  value: '$12.000'
}];
export function Bonuses() {
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream-light inline-flex items-center justify-center gap-4" data-id="element-16">
            <Gift className="w-10 h-10 text-brand-accent" data-id="element-17" />6 BONOS — SIEMPRE
            INCLUIDOS
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-18">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col md:flex-row items-start md:items-center gap-4 bg-brand-darker p-6 rounded-xl border border-brand-primary/20" data-id="element-19">
              <div className="flex items-center gap-4 w-full md:w-auto md:min-w-[120px]" data-id="element-20">
                <span className="text-3xl font-serif text-brand-primary/40 font-bold" data-id="element-21">
                  #{bono.num}
                </span>
                <Gift className="w-6 h-6 text-brand-gold hidden md:block" data-id="element-22" />
              </div>

              <div className="flex-1" data-id="element-23">
                <h4 className="text-xl font-bold text-brand-cream-light mb-1" data-id="element-24">
                  {bono.title}
                </h4>
                <p className="text-brand-primary" data-id="element-25">{bono.desc}</p>
              </div>

              <div className="flex items-center gap-4 w-full md:w-auto justify-between md:justify-end mt-4 md:mt-0 pt-4 md:pt-0 border-t border-brand-primary/10 md:border-t-0" data-id="element-26">
                <span className="text-brand-primary/60 line-through text-lg" data-id="element-27">
                  {bono.value}
                </span>
                <span className="bg-brand-accent text-brand-darker font-bold px-4 py-1 rounded-full text-sm" data-id="element-28">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-brand-gold/10 border border-brand-gold/30 p-6 rounded-2xl" data-id="element-29">
          <p className="text-2xl md:text-3xl font-serif text-brand-cream-light" data-id="element-30">
            Valor total bonos:{' '}
            <span className="line-through text-brand-primary/60 mx-2" data-id="element-31">
              $71.000
            </span>
            <span className="text-brand-gold font-bold" data-id="element-32">
              → GRATIS con tu Pack
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}